<template>
  <div>
    <!-- 大图预览 -->
    <el-dialog
        :title="titleH"
        :visible.sync="show"
        :width="widths"
        center
        :close-on-click-modal="false"
    >
      <div class="" style="display: flex;overflow: auto;">
        <div v-for="(item, index) in srcList" :key="index">
          <el-image
              style="width: 180px; height: 180px; margin: 10px"
              :src="item"
              :preview-src-list="srcList"
              :initial-index="index"
              fit="cover"
          >
          </el-image>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" size="mini" @click="closeDialog">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "LookBigImgs",
  props: {
    titleH: {
      type: String,
      default: "",
    },
    widths: {
      type: String,
      default: "50%",
    },
    bigImgsShow: {
      type: Boolean,
      default: false,
    },
    srcList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
    };
  },
  watch: {
    bigImgsShow: {
      handler(n) {
        this.show = n;
      },
      immediate: true
    },
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog", false);
    },
  },
};
</script>

<style scoped>
</style>
